import React, {useCallback, useContext, useEffect} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import HideAppBar from "../../widgets/header/HideAppBar";
import {
    Avatar,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Container,
    FormControlLabel,
    Radio,
    RadioGroup,
    Tooltip,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import {RadioGroupQuestion} from "../../widgets/inputs/RadioGroupQuestion";
import {useForm} from "react-hook-form";
import {AppContext} from "../../../App";
import {setThemeType, setUserAvatar} from "../../../services/AppServices";
import Button from "@mui/material/Button";
import {indigo, lightBlue, purple, red} from "@mui/material/colors";
import {getAccountInfo, getUserNameAndSurname} from "../../../utils/GenericUtils";
import moment from "moment";
import CameraAltTwoToneIcon from '@mui/icons-material/CameraAltTwoTone';
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";

const ProfiloPersonale = () => {
    const classes = BaseStyle();
    const appContext = useContext(AppContext);
    const {control, errors, getValues, handleSubmit, register, watch} = useForm({
        mode: "onChange",
        defaultValues: {
            theme: "light",
            fontSize: "16",
            appBarColor: "1",
        }
    });

    const previewChanges = useCallback(() => {
        let data = getValues();
        let primary = {};
        switch (data.appBarColor) {
            default:
                primary = {
                    main: data.theme === "light" ? indigo["A700"] : lightBlue[500],
                    light: lightBlue["A100"],
                    dark: lightBlue["A700"],
                };
                break;
            case "2":
                primary = {
                    main: data.theme === "light" ? red[500] : red[900],
                    light: red["A100"],
                    dark: red["A700"],
                };
                break;
            case "4":
                primary = {
                    main: data.theme === "light" ? purple[500] : purple[900],
                    light: purple["A100"],
                    dark: purple["A700"],
                };
                break;

        }
        setThemeType(data.theme, null, appContext.dispatch, data.fontSize, primary);
    }, [getValues, appContext.dispatch])

    const onSubmit = useCallback((data) => {
        console.log(data);
        setUserAvatar(data, appContext.dispatch)
    }, [appContext.dispatch]);

    useEffect(() => {

    }, [])

    useEffect(() => {
        document.body.style = `background: none;`;
    }, []);

    return (
        <React.Fragment>
            <main className={classes.main}>
                <HideAppBar title={"Profilo personale"}/>
                <Container maxWidth={"md"} component={"article"} style={{paddingTop: 12}}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Card className={clsx(classes.roundBorder)}
                                      style={{height: "100%", display: "flex", flexDirection: "column"}}>
                                    <CardHeader
                                        title={<Typography variant={"h6"}><b>Foto profilo</b></Typography>}
                                        subheader={"Visualizza o modifica la foto profilo del tuo account"}
                                    />
                                    <CardContent style={{flexGrow: 1}}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={3} style={{position: "relative"}}
                                                  className={classes.showOnHover}>
                                                <Avatar className={classes.ultraLarge}>
                                                    <SVG src={multiavatar(getAccountInfo().username)}/>
                                                </Avatar>
                                                <input ref={register}
                                                       name={"userPicture"}
                                                       accept="image/*"
                                                       style={{display: "none"}}
                                                       id="raised-button-docRetro"
                                                       type="file"/>
                                                <label htmlFor="raised-button-docRetro">
                                                    <CameraAltTwoToneIcon className={classes.visibleOnHover}/>
                                                </label>
                                            </Grid>
                                            <Grid item xs={12} sm={9}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12}>
                                                        <Typography variant={"h4"}>
                                                            <b>{getUserNameAndSurname()}</b>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant={"h6"}>
                                                            <b>{getAccountInfo().gruppo}</b>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={4} style={{paddingTop: 12}}>
                                                        <Typography variant={"subtitle1"}>
                                                            Data registrazione:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8} style={{paddingTop: 12}}>
                                                        <Typography variant={"subtitle1"} color={"textSecondary"}>
                                                            {moment(getAccountInfo().dataRegistrazione).format("DD/MM/YYYY HH:mm")}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Typography variant={"subtitle1"}>
                                                            Data ultimo accesso
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Typography variant={"subtitle1"} color={"textSecondary"}>
                                                            {moment(getAccountInfo().ultimoAccesso).format("DD/MM/YYYY HH:mm")}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {
                                                            getAccountInfo().roles?.map(role => {
                                                                return <Chip key={role} avatar={<Avatar>R</Avatar>}
                                                                             label={role.replace("ROLE_", "")}
                                                                             style={{margin: 4}} color={"primary"}/>
                                                            })
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <CardActions className={classes.flexRight}>
                                        <Tooltip title={"Carica una foto in cui sei sexy"}>
                                            <Button variant={"contained"} color={"primary"} disableElevation
                                                    className={classes.roundButton}
                                                    size={"small"} onClick={handleSubmit(onSubmit)}>
                                                <b>Cambia foto</b>
                                            </Button>
                                        </Tooltip>
                                    </CardActions>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card className={clsx(classes.roundBorder)}
                                      style={{height: "100%", display: "flex", flexDirection: "column"}}>
                                    <CardHeader
                                        title={<Typography variant={"h6"}><b>Impostazioni personali</b></Typography>}
                                        subheader={"Modifica le impostazioni del tema e molto altro per questo account"}
                                    />
                                    <CardContent style={{flexGrow: 1}}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <RadioGroupQuestion
                                                    question={"Tema di base dell'applicazione"}
                                                    name={"theme"}
                                                    control={control}
                                                    autoFocus={true}
                                                    defaultValue={"light"}
                                                    rules={{required: true}}
                                                    error={errors["theme"]}
                                                    radioGroup={
                                                        <RadioGroup autoFocus={true} row={true}>
                                                            <FormControlLabel control={<Radio/>} label={"CHIARO"}
                                                                              value={"light"} key={2}/>
                                                            <FormControlLabel control={<Radio/>} label={"SCURO"}
                                                                              value={"dark"} key={3}/>
                                                        </RadioGroup>
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <RadioGroupQuestion
                                                    question={"Grandezza del font"}
                                                    name={"fontSize"}
                                                    control={control}
                                                    autoFocus={true}
                                                    defaultValue={"16"}
                                                    rules={{required: true}}
                                                    error={errors["fontSize"]}
                                                    radioGroup={
                                                        <RadioGroup autoFocus={false} row={true}>
                                                            <FormControlLabel control={<Radio/>} label={"16"}
                                                                              value={"16"} key={1}/>
                                                            <FormControlLabel control={<Radio/>} label={"17"}
                                                                              value={"17"} key={2}/>
                                                            <FormControlLabel control={<Radio/>} label={"18"}
                                                                              value={"18"} key={3}/>
                                                            <FormControlLabel control={<Radio/>} label={"19"}
                                                                              value={"19"} key={4}/>
                                                            <FormControlLabel control={<Radio/>} label={"20"}
                                                                              value={"20"} key={5}/>
                                                        </RadioGroup>
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <RadioGroupQuestion
                                                    question={"Cpolore della barra superiore"}
                                                    name={"appBarColor"}
                                                    control={control}
                                                    autoFocus={true}
                                                    defaultValue={"1"}
                                                    rules={{required: true}}
                                                    error={errors["appBarColor"]}
                                                    radioGroup={
                                                        <RadioGroup autoFocus={false} row={true}>
                                                            <FormControlLabel control={<Radio/>} label={"BLU"}
                                                                              value={"1"} key={1}/>
                                                            <FormControlLabel control={<Radio/>} label={"ROSSA"}
                                                                              value={"2"} key={2}/>
                                                            <FormControlLabel control={<Radio/>} label={"VERDE"}
                                                                              value={"3"} key={3}/>
                                                            <FormControlLabel control={<Radio/>} label={"VIOLA"}
                                                                              value={"4"} key={4}/>
                                                            <FormControlLabel control={<Radio/>} label={"GIALLA"}
                                                                              value={"5"} key={5}/>
                                                        </RadioGroup>
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                colore sfondo?
                                            </Grid>
                                            <Grid item xs={12}>
                                                colore secondario?
                                            </Grid>
                                            <Grid item xs={12}>
                                                Mostra notifiche? [solo badge, notifica intera a video (stile
                                                instagram)]
                                            </Grid>
                                            <Grid item xs={12}>
                                                Sincronizzazione notifiche? [ogni 5 secondi, ogni (15) secondi, ogni 5
                                                minuti, ogni ora]
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <CardActions className={classes.flexRight}>
                                        <Tooltip
                                            title={"Visualizza un anteprima delle modifiche da te richieste"}>
                                            <Button variant={"text"} disableElevation size="small" color="inherit"
                                                    className={classes.roundButton} onClick={previewChanges}>
                                                <b>Anteprima</b>
                                            </Button>
                                        </Tooltip>
                                        <Tooltip
                                            title={"Visualizza un anteprima delle modifiche da te richieste"}>
                                            <Button variant={"contained"} disableElevation size="small" color="primary"
                                                    className={classes.roundButton}>
                                                <b>Applica modifiche</b>
                                            </Button>
                                        </Tooltip>
                                    </CardActions>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </main>
        </React.Fragment>
    );
}

export default React.memo(ProfiloPersonale)
